import { render, staticRenderFns } from "./BarCodeRulesSelect.vue?vue&type=template&id=71a87f04&scoped=true&"
import script from "./BarCodeRulesSelect.vue?vue&type=script&lang=js&"
export * from "./BarCodeRulesSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a87f04",
  null
  
)

export default component.exports